import { useCallback } from 'react';
import warning from 'warning';
export const useTriggerProps = ({ triggers, handleHide, handleShow, handleToggle, onFocus, onBlur, onClick })=>{
    const handleFocus = useCallback((...args)=>{
        handleShow();
        onFocus?.(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = useCallback((...args)=>{
        handleHide();
        onBlur?.(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = useCallback((...args)=>{
        handleToggle();
        if (onClick) onClick(...args);
    }, [
        onClick,
        handleToggle
    ]);
    const handleMouseOver = useCallback((...args)=>{
        handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = useCallback((...args)=>{
        handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggerProps = {};
    if (triggers.includes('click')) {
        triggerProps.onClick = handleClick;
    }
    if (triggers.includes('focus')) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.includes('hover')) {
        warning(triggers.length > 1, 'Specifying only the `"hover"` trigger limits the visibility of the overlay to just mouse users. Consider also including the `"focus"` trigger so that touch and keyboard only users can see the overlay as well.');
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return triggerProps;
};
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
const handleMouseOverOut = (handler, args, relatedNative)=>{
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !target.contains(related)) {
        handler(...args);
    }
};
